/*
 *
 * MultiMerchantSelect
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 20-Nov-2024
 */

import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  search: <PortalMessage id='t.app.header.title.search.title' defaultMessage='Search' />,
  results: <PortalMessage id='t.app.header.title.search.results' defaultMessage='Total shops' />,
  searchResults: <PortalMessage id='t.app.header.title.search.searchResults' defaultMessage='Search result' />,
  pointOfSale: <PortalMessage id='t.app.header.title.search.pointOfSale' defaultMessage='Point of sale' />,
  merchantId: <PortalMessage id='t.app.header.title.search.merchantId' defaultMessage='Merchant ID: ' />,
  moreResults: (
    <PortalMessage id='t.app.header.title.search.moreResults' defaultMessage='Use search to see more results' />
  )
}

export const messages = defineMessages({
  search_alt: {
    id: 't.app.accessibility.header.title.search.alt.ariaLabel',
    defaultMessage: 'Search'
  },
  search_placeholder: {
    id: 't.app.header.title.search.placeholder',
    defaultMessage: 'Point of sale search'
  },
  cancel_label: {
    id: 't.app.accessibility.header.title.search.cancelLabel.ariaLabel',
    defaultMessage: 'Cancel'
  }
})

export default formattedMessage
